module.exports = __webpack_public_path__ + "static/media/3.ce491830.jpg";